import {
  ClockCircleOutlined,
  PauseCircleOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import { Button, Col, DatePicker, Modal, Row, Select } from "antd";
import { useEffect } from "react";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import LabelText from "../../../components/input/LabelText";
import LabelTextarea from "../../../components/input/LabelTextarea";
import {
  startPostConcluirServicio,
  startUpdateFecha,
} from "../../../context/actions/detalleActions";
import { dateFromString } from "../../../utils/dateFromString";

export const Concluido = ({ asistencia: { estatusID, fechaConcluido } }) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [fecha, setFecha] = useState();
  const { estatusFinalID, folioGnp, esGnpApi, localCarretero, costo } = useSelector(
    (state) => state.detalleReducer.asistencia
  );

  const { lp1, lp2 } = useSelector((state) => state.detalleReducer.proveedorCostos);

  const { usuarioID } = useSelector((state) => state.userReducer.user);

  ///
  const { asistenciaID } = useParams();
  const [show, setShow] = useState(false);
  const [data, setData] = useState({ costo, estatusFinal: 2 });
  const [costoPersonalizado, setCostoPersonalizado] = useState(false);

  useEffect(() => {
    setData({
      ...data,
      costo: localCarretero === "local" ? undefined : costo,
    });
  }, [costo]);

  const isDisabled = () => {

    if (data.costo < 0 || data.costo === "" || data.costo === undefined) return true;
    if (!fecha) return true;
    return false;
  };

  //
  const handleChange = ({ target }) => {
    setData({
      ...data,
      [target.name]: target.value,
    });
  };

  const handleSelectChange = (value) => {
    if (value === "personalizado") {
      setCostoPersonalizado(true);
      setData({
        ...data,
        costo: undefined,
      });
    } else {
      setCostoPersonalizado(false);
      setData({
        ...data,
        costo: value,
      });
    }
  };

  const submit = async () => {
    if (!fecha) return;

    const body = {
      ...data,
      costo: data.costo,
      asistenciaID,
      usuarioID,
      folioGnp,
      esGnpApi,
      fecha,
    };

    const result = await dispatch(startPostConcluirServicio(body));

    if (result?.ok) {
      setData({});
      setShow(false);
    }
  };

  const handleCambiarFecha = () => {
    const body = {
      fecha,
      asistenciaID,
      tipo: 3, // conclusion
    };
    dispatch(startUpdateFecha(body));

    setShowModal(false);
  };

  const onDateChange = (momentTime, stringTime) => setFecha(stringTime);

  ////////////////////////////
  if (estatusID === 5 && estatusFinalID === 1)
    return (
      <>
        <div onClick={() => setShow(true)} className="marcarStep">
          <PauseCircleOutlined /> Marcar concluido
        </div>

        <Modal
          title="Concluir Servicio"
          open={show}
          onCancel={() => setShow(false)}
          footer={null}
        >
          <Row>
            <Col
              span={6}
              style={{ color: "green", textAlign: "center", paddingTop: 10 }}
            >
              <CheckCircleOutlined style={{ fontSize: 60 }} />
            </Col>
            <Col span={18}>
              <div style={{ marginBottom: 10 }}>
                <div className="inputLabel">Fecha y Hora</div>
                <DatePicker
                  style={{ width: "100%" }}
                  placeholder="Fecha y Hora"
                  showTime
                  onChange={onDateChange}
                />
              </div>

              <div style={{ marginBottom: 10 }}>
                {localCarretero === "local" ? (
                  <>
                    <div className="inputLabel">Plano</div>
                    <Select
                      style={{ width: "100%" }}
                      placeholder="Selecciona un plano"
                      onChange={handleSelectChange}
                      value={costoPersonalizado ? "personalizado" : data.costo}
                    >
                      <Select.Option value={lp1}>Plano 1 (${lp1})</Select.Option>
                      <Select.Option value={lp2}>Plano 2 (${lp2})</Select.Option>
                      <Select.Option value="personalizado">Definir costo</Select.Option>
                    </Select>
                    {costoPersonalizado && (
                      <div style={{ marginTop: 10 }}>
                        <LabelText
                          onChange={handleChange}
                          label="Costo"
                          name="costo"
                          value={data.costo}
                        />
                      </div>
                    )}
                  </>
                ) : (
                  <LabelText
                    onChange={handleChange}
                    label="Costo final"
                    name="costo"
                    value={data.costo}
                  />
                )}
              </div>
              <div>
                <LabelTextarea
                  value={data.comentarios}
                  onChange={handleChange}
                  label="Comentarios finales"
                  name="comentarios"
                />
              </div>
            </Col>
          </Row>

          <div style={{ textAlign: "center", marginTop: 20 }}>
            <Button onClick={submit} disabled={isDisabled()} type="primary">
              Concluir el Servicio
            </Button>
          </div>
        </Modal>
      </>
    );

  ////////////////////////////
  const date = dateFromString(fechaConcluido);

  if (estatusID > 5)
    return (
      <div onDoubleClick={() => setShowModal(true)}>
        <ClockCircleOutlined /> {date.dateStep}
        <Modal
          title="Cambiar Fecha Conlcuido"
          open={showModal}
          onOk={handleCambiarFecha}
          onCancel={() => setShowModal(false)}
        >
          <DatePicker showTime onChange={onDateChange} />
        </Modal>
      </div>
    );

  ////////////////////////////
  return <div></div>;
};
